import React from 'react';
import { Modal } from 'react-bootstrap';

const ButtonModals = ({ show, handleClose, title, content }) => {

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {content}
            </Modal.Body>
        </Modal>
    );
};

export default ButtonModals;